<template>
  <div class="panel-container">
    <!-- eLink策略 -->
    <div class="card-container" v-if="isElink">
      <div class="info-container">
        <span class="info-text">{{ $str.getKey('策略控制/eLink策略') }}</span>
        <span class="info-text">
          {{ $str.getKey('策略控制/需量') }}: <b class="value-text">{{currentELinkData?.demand_current ? currentELinkData?.demand_current : '--'}}kW</b>
          </span>
        <span class="info-text">
          {{ $str.getKey('策略控制/允许虚拟电厂调度') }}: <b class="value-text">{{translateThirdCtrl(currentELinkData?.third_ctl_en_current)}}</b>
        </span>
        <span class="info-text" v-if="currentELinkData?.strategy_updated_time != null">
          {{ $str.getKey('策略控制/同步时间') }}：<b class="value-text">{{formmatTime(currentELinkData?.strategy_updated_time)}}</b>
        </span>
        <span class="info-text" v-if="currentELinkData?.result_code != null && currentELinkData?.result_code != 200">
          {{ $str.getKey('策略控制/同步结果') }}：<b class="value-text">{{translateResultCode(currentELinkData?.result_code)}}</b>
        </span>
      </div>
      <div class="chart-body">
        <v-chart :option="optionELink" :autoresize="true"></v-chart>
      </div>
    </div>
    <!-- eMind策略 -->
    <div class="card-container" v-else>
      <div class="info-container">
        <span class="info-text">{{ $str.getKey('策略控制/eMind策略') }}</span>
        <span class="info-text">{{ $str.getKey('策略控制/需量') }}: <b class="value-text">{{ currentELinkData?.demand }}kW</b></span>
        <span class="info-text">
          {{ $str.getKey('策略控制/允许虚拟电厂调度') }}: <b class="value-text">{{translateThirdCtrl(currentELinkData?.third_ctl_en)}}</b>
        </span>
      </div>
      <div class="chart-body">
        <v-chart :option="option" :autoresize="true"></v-chart>
      </div>
    </div>

  </div>
</template>


<script setup>
import { computed } from "vue"
import VChart from 'vue-echarts'
import { createOption, translateThirdCtrl, translateResultCode, formmatTime } from "../utils.js"

const $str = window.$str;
const props = defineProps({
  currentELinkData: {
    type: Object,
    default: () => ({}),
  },
  isElink: {
    type: Boolean,
    default: false,
  }
})

function getEMindStrategyData() {
  let current = props.currentELinkData
  if (current) {
    if (current.strategy_type === 'work') {
      return current.strategys_work
    } else if (current.strategy_type === 'rest') {
      return current.strategys_rest
    }
  }
}


const option = computed(() => {
  let emindStrategy = getEMindStrategyData()
  let opt = createOption(emindStrategy, props.currentELinkData?.powerLimit)
  return opt
})

const optionELink = computed(() => {
  let opt = createOption(props.currentELinkData?.strategys_current, props.currentELinkData?.powerLimit)
  return opt
})

</script>
<style lang="scss" scoped>
.panel-container {

  width: 100%;
  height: 100%;
  .card-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    .info-container {
      margin-left: 32px;
      padding: 8px;
      border-radius: 4px;
      // @apply bg-gray-100;
      display: flex;
      gap: 40px;
      font-family: PingFang-SC, PingFang-SC;
      // font-weight: bold;
      font-size: 16px;
      line-height: 23px;
      text-align: left;
      .info-text {
        color: #00000080;
      }
      .value-text {
        color:#00000080;
        margin-left: 10px;
      }

    }
    .chart-body {
      width: 100%;
      flex: 1 1 250px;
    }
  }
  
}
</style>